import React from 'react'

import { severalSideTextEscapeString } from '@constant/index'
import { classNames } from '@lib/simpleFn'

type ChoiceTextProps = {
  setChoice: (choice: number) => void
  text: string
  textClassName: string
  number: number
}

const ChoiceText: React.FC<ChoiceTextProps> = ({ setChoice, text, textClassName, number }) => {
  if (text.includes(severalSideTextEscapeString)) {
    const texts = text.split(severalSideTextEscapeString)
    return (
      <div
        className={classNames(
          'relative flex w-full whitespace-pre-wrap break-all cursor-pointer translate-y-px mb-4',
          textClassName
        )}
        onClick={() => setChoice(number)}
      >
        {texts.map((text) => {
          return (
            <pre
              key={text}
              className={classNames(
                `w-[calc(50%-5px)]`,
                `text-left sd:w-auto whitespace-pre-wrap first:ml-[0px] ml-[10px] leading-6`
              )}
            >
              {text}
            </pre>
          )
        })}
      </div>
    )
  }

  return (
    <pre
      className={classNames(
        'whitespace-pre-wrap break-all cursor-pointer translate-y-px',
        textClassName
      )}
      onClick={() => setChoice(number)}
    >
      {text}
    </pre>
  )
}

export default ChoiceText
